<mat-sidenav-container class="sidenav-container" hasBackdrop="false" style="position: fixed; z-index: 1000">
  <mat-sidenav
    mode="over"
    class="sidenav-content"
    [disableClose]="true"
    [class.opened-sidenav]="openedSidenav()"
    [opened]="opened()"
    (openedChange)="opened.set($event)"
    (transitionend)="onTransitionEnd()"
    (transitioncancel)="openedSidenav.set(openedSidenav())"
    (transitionstart)="openedSidenav.set(false)"
    (transitionrun)="openedSidenav.set(false)"
  >
    <ng-content />
  </mat-sidenav>
</mat-sidenav-container>
